export default [
  {
    path: "/academy-dashboard",
    name: "academy-main",
    component: () => import("../../modules/Academy/pages/AcademyDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["tutor", "academy"],
    },
  },
  {
    path: "/bot-feedbacks",
    name: "bot-feedbacks-main",
    component: () =>
      import("../../modules/Academy/pages/BotFeedbacks/BotFeedbacks.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/branchacademy-dashboard",
    name: "branchacademy-main",
    component: () => import("../../modules/BranchAcademy/BranchAcademy.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["branchacademy", "academy"],
    },
  },
  {
    path: "/academy-teacher-list",
    name: "mentors-list-main",
    component: () =>
      import("../../modules/Admin/pages/MentorsList/MentorsList.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["admin", "academy", "branchManager"],
    },
  },
  {
    path: "/teacher-info/:id",
    name: "mentor-info",
    component: () =>
      import("../../modules/Academy/pages/MentorInfo/MentorInfo.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["admin", "academy", "teacher", "branchManager", "finance", "kurator"],
    },
  },
  {
    path: "/teacher-statistics",
    name: "teacher-main-statistics",
    component: () =>
      import("../../modules/Academy/pages/TeacherStat/TeacherStatistics.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["admin", "academy", "branchManager"],
      manager: "academy",
    },
  },
  {
    path: "/academy-courses",
    name: "academy-courses",
    component: () => import("../../modules/Academy/pages/Courses/Courses.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy", "branchacademy", "metodist"],
    },
  },
  {
    path: "/academy-courses/:id",
    name: "academy-course-elements",
    component: () =>
      import("../../modules/Academy/pages/Courses/CourseElements.vue"),
    alias: ["/academy-corses/:id"],
    meta: {
      auth: true,
      layout: "main",
      role: ["academy", "branchacademy", "metodist"],
    },
  },
  {
    path: "/teachers-lessons-schedule",
    name: "teachers-lessons-schedule-main",
    component: () =>
      import("../../modules/Academy/widgets/TutorsRating/TutorsRating.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
      manager: "academy",
    },
  },
  {
    path: "/tutor-rating/:id",
    name: "tutor-rating",
    component: () =>
      import(
        "../../modules/Academy/widgets/TutorsRating/TutorRatingLessons.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
      manager: "academy",
    },
  },

  {
    path: "/students-results",
    name: "students-results-main",
    component: () =>
      import("../../modules/Academy/pages/StudentsResults/StudentsResults.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
      manager: "academy",
    },
  },
  {
    path: "/academy-archived-students",
    name: "academy-archived-students-main",
    component: () =>
      import(
        "../../modules/Academy/pages/AcademyArchivedStudents/AcademyArchivedStudents.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy", "admin"],
      manager: "academy",
    },
  },
  {
    path: "/attendance-statistics",
    name: "attendance-statistics-main",
    component: () => import("../../modules/Academy/pages/AttendanceStatistics/AttendanceStatistics.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/quiz-health",
    name: "quiz-health",
    component: () => import("../../modules/Academy/pages/QuizHealth/QuizHealthDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/academy-surveys",
    name: "academy-surveys",
    component: () =>
      import(
        "../../modules/Academy/pages/Surveys/Surveys.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/academy-surveys/geo",
    name: "academy-geo-survey",
    component: () =>
      import(
        "../../modules/Administration/pages/GeoSurvey/GeoSurvey.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/academy-surveys/topics",
    name: "academy-topic-survey",
    component: () =>
      import(
        "../../modules/Academy/pages/TopicSurvey/TopicSurvey.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/academy-surveys/lessons",
    name: "academy-lesson-ratings",
    component: () =>
      import(
        "../../modules/Academy/pages/LessonRatings/LessonRatings.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/academy-nabors",
    name: "academy-nabors",
    component: () =>
      import("../../modules/Academy/pages/AcademyNabors/AcademyNabors.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
  {
    path: "/it-support-log",
    name: "it-support-log",
    component: () => import("../../modules/Academy/pages/ITSupportLog/ITSupportLog.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["academy"],
    },
  },
];
